import { formatCnpj } from 'commons/utils/string'
import type {
  Channels,
  Company,
  CustomerType,
  Offices,
  Organization,
  Sectors,
} from 'constants/enums'

import type {
  Customer,
  CustomerApi,
  CustomersRequestData,
  CustomersRequestDataApi,
  CustomersResponseData,
  CustomersResponseDataApi,
} from './types'

export const toCustomer = (customerApi: CustomerApi): Customer => {
  return {
    address: {
      addressFormatted: customerApi.enderecoCliente.enderecoFormatado,
      city: customerApi.enderecoCliente.cidade,
      complement: customerApi.enderecoCliente.complemento,
      district: customerApi.enderecoCliente.bairro,
      number: customerApi.enderecoCliente.numero,
      state: customerApi.enderecoCliente.estado,
      street: customerApi.enderecoCliente.endereco,
    },
    cnpj: customerApi.cnpj,
    cnpjFormatted: formatCnpj(customerApi.cnpj),
    commercialStructure: {
      idCompany: customerApi.estruturaComercial.codigoEmpresa as Company,
      idMarket: customerApi.estruturaComercial.codigoCanal as Channels,
      idOffice: customerApi.estruturaComercial.codigoEscritorio as Offices,
      idOrganization: customerApi.estruturaComercial.codigoOrganizacao as Organization,
      idRegional: customerApi.estruturaComercial.codigoReginal,
      idSector: customerApi.estruturaComercial.codigoSetor as Sectors,
      idZone: customerApi.estruturaComercial.codigoZona,
    },
    id: customerApi.codigo,
    name: customerApi.nome,
    stateTaxRegistration: customerApi.inscricaoEstatual,
    type: customerApi.tipo as CustomerType,
  }
}

export const toCustomerApi = (customer: Customer) => {
  return {
    cnpj: customer.cnpj,
    codigo: customer.id,
    enderecoCliente: {
      bairro: customer.address.district,
      cidade: customer.address.city,
      complemento: customer.address.complement,
      endereco: customer.address.street,
      enderecoFormatado: customer.address.addressFormatted,
      estado: customer.address.state,
      numero: customer.address.number,
    },
    estruturaComercial: {
      codigoCanal: customer.commercialStructure.idMarket as string,
      codigoEmpresa: customer.commercialStructure.idCompany as string,
      codigoEscritorio: customer.commercialStructure.idOffice as string,
      codigoOrganizacao: customer.commercialStructure.idOrganization as string,
      codigoReginal: customer.commercialStructure.idRegional,
      codigoSetor: customer.commercialStructure.idSector as string,
      codigoZona: customer.commercialStructure.idZone,
    },
    inscricaoEstatual: customer.stateTaxRegistration,
    nome: customer.name,
    tipo: customer.type as string,
  }
}

export const toCustomersResponseData = (
  response: CustomersResponseDataApi,
): CustomersResponseData => {
  const { data, pagination } = response

  const customers = data.map((customer) => {
    return toCustomer(customer)
  })

  return {
    data: customers,
    pagination,
  }
}

export const toCustomersRequestDataApi = (body: CustomersRequestData): CustomersRequestDataApi => {
  return {
    codigoCanal: body.commercialStructure?.idMarket ?? null,
    codigoEscritorio: body.commercialStructure?.idOffice ?? null,
    codigoReginal: body.commercialStructure?.idRegional ?? null,
    codigoSetor: body.commercialStructure?.idSector ?? null,
    codigoZona: body.commercialStructure?.idZone ?? null,
    pesquisa: body.search,
  }
}
